import type { InferType } from 'yup'
import { string } from 'yup'

export const STUDY_ID_MAX_LENGTH = 200

/** Matches the airlock-be / api-server OpenAPI `StudyId` pattern. */
export const STUDY_ID_PATTERN = /^(?:[\x21-\x7E]|[\x21-\x7E][\x20-\x7E]{0,198}[\x21-\x7E])$/

/**
 * Printable ASCII only, 1-200 characters, no leading or trailing space; repeated internal
 * spaces are allowed. BE rejects a malformed value with 400 and never trims or normalises it,
 * so callers must normalise input themselves via `normalizeStudyIdInput`.
 *
 * `excludeEmptyString` keeps an empty value on the required/min messages instead of the
 * pattern message, which yup 0.32 would otherwise report non-deterministically.
 */
export const buildStudyIdSchema = () =>
  string()
    .required('Study ID is required')
    .min(1, 'Study ID is required')
    .max(STUDY_ID_MAX_LENGTH, `Study ID must be at most ${STUDY_ID_MAX_LENGTH} characters`)
    .matches(STUDY_ID_PATTERN, {
      message: 'Study ID must use printable ASCII characters only and cannot start or end with a space',
      excludeEmptyString: true
    })

/** Shared Study ID validator — use `buildStudyIdSchema()` when chaining modifiers to avoid mutating this instance. */
export const studyIdSchema = buildStudyIdSchema()

export type StudyId = InferType<ReturnType<typeof buildStudyIdSchema>>
